import { useState } from 'react';
import { Col, Row } from 'reactstrap';
import TableActions from 'components/layouts/table';
import Table, { useTable } from 'common/components/table';
import useDrawer from 'common/components/drawer/useDrawer';
import EnumsDropdown from '../Dropdown';
import edit from 'assets/svg/actions/edit.svg';
import bin from 'common/assets/svg/common/bin.svg';
import { useActions } from 'utils/hooks';
import * as crewMatrixActions from 'common/components/crew/components/matrices/store/actions';
import MatricesDrawer from 'common/components/crew/components/matrices/drawer';
import DangerousActionModal from 'common/components/modals/DangerousActionModal';

const CrewMatrix = () => {
  const [active, setActive] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteCrewMatrix] = useActions([crewMatrixActions.deleteCrewMatrix]);
  const drawer = useDrawer();

  const table = useTable({
    label: 'crew_matrices',
    columns: [
      {
        header: 'Name',
        key: 'name',
        type: 'string',
        sort: false,
        canFilter: false
      },
      {
        header: 'Actions',
        key: 'actions',
        field: 'actions',
        className: 'text-center',
        width: 1
      }
    ]
  });

  const deleteCrewMatrixAction = async () => {
    if (!active) return;

    try {
      await deleteCrewMatrix({
        id: active.id,
        is_active: !active.is_active
      }).unwrap();

      table.refetchData();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Row>
      <Col xs={12} className="mb-5 mt-n1">
        <TableActions
          documentTitle="Crew Matrix"
          title="Enums"
          dropdown={<EnumsDropdown />}
          actions={[
            {
              type: 'add',
              text: 'Create new',
              color: 'primary',
              onClick: () => {
                setActive();
                drawer.open();
              }
            }
          ]}
        />
      </Col>
      <Col xs={12}>
        <Table
          loader
          hideTableFilters
          rows={{
            actions: () => ({
              options: [
                {
                  label: 'Edit',
                  icon: edit,
                  onClick: (_, row) => {
                    setActive(row);
                    drawer.open();
                  }
                },
                {
                  label: 'Delete',
                  icon: bin,
                  onClick: (_, row) => {
                    setActive(row);
                    setShowDeleteModal(true);
                  }
                }
              ]
            })
          }}
          {...table}
        />

        <MatricesDrawer drawer={drawer} refetchData={table.refetchData} active={active} isOcean />

        <DangerousActionModal
          transparent
          action={'Delete'}
          onAccept={deleteCrewMatrixAction}
          closeModal={() => setShowDeleteModal(false)}
          isOpen={showDeleteModal}
          actionText={'Delete'}
          header={'Delete'}
          body={`Are you sure you want to delete this crew matrix?`}
        />
      </Col>
    </Row>
  );
};

export default CrewMatrix;
